/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { PathProps } from '../utils/UNSAFE_visTypes/common';

const HUMAN_PATH_CMDS =
  'M 49.973566845209916 0 C 35.487299168442284 0 23.71094058258365 12.495019801980108 23.71094058258365 27.90841584158416 C \
  23.71094058258365 43.32181188118821 35.487299168442284 55.81683168316832 49.973566845209916 55.81683168316832 C 64.4599001785434 \
  55.81683168316832 76.23619310783617 43.32181188118821 76.23619310783617 27.90841584158416 C 76.23619310783617 12.495019801980108 \
  64.4599001785434 0 49.973566845209916 0 z M 19.607405229048297 50.541460396039604 C 10.737203208846282 57.250371287128864 \
  -3.3723927507496847 73.51485148514851 0.7311426027856692 89.17079207920791 C 23.783162804806032 103.5633663366335 68.33114260278562 \
  105.4951732673267 100.03669815834124 88.31992574257426 C 101.26447593611908 71.04665841584145 91.18619310783609 58.7152227722771 \
  79.51902139066446 50.541460396039604 C 64.74629411793718 75.89591584158418 36.02154664318971 70.79344059405938 19.607405229048297 50.541460396039604 z';

// only human is supported for now.
export const Path = ({
  scaleX,
  scaleY,
  tx,
  ty,
  fill,
  stroke,
  strokeWidth = 1,
  width,
  height,
  isInteractive,
  dataInfo
}: PathProps) => {
  const sX = (scaleX * width) / 100;
  const sY = (scaleY * height) / 100;
  return (
    <path
      {...dataInfo}
      fill={fill}
      stroke={stroke}
      strokeWidth={strokeWidth}
      vectorEffect="non-scaling-stroke"
      cursor={isInteractive ? 'pointer' : undefined}
      transform={`translate(${tx - width / 2} ${ty - height / 2}) scale(${sX} ${sY})`}
      d={HUMAN_PATH_CMDS}
    />
  );
};
